module.exports = __webpack_public_path__ + "static/media/brand08.2faf1909.png";